const getTaskIcon = categoryTitle => {
  switch (categoryTitle) {
    case 'registration':
      return 'content_paste';
    case 'cost_collection':
      return 'attach_money';
    case 'cost_review':
      return 'schedule';
    case 'technical_assessment':
      return 'search';
    case 'review_submission':
      return 'rate_review';
    case 'claim_management':
      return 'calendar_today';
    default:
      return 'assignment';
  }
};
export default getTaskIcon;